//存储token
export const setToken = (token) => {
  //持久化存储token
  localStorage.setItem("TOKEN", token)
}

//获取token
export const getToken = () => {
  return localStorage.getItem("TOKEN")
}

export const removeToken = () => {
  localStorage.removeItem("TOKEN")
}


// WEBPACK FOOTER //
// ./src/utils/token.js